import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { TOKEN_KEY } from "../api";
import { useAuth } from "../AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      const hash = window.location.hash || "";
      // Extract session_id from #session_id=xxx OR fallback to ?session_id
      const m = hash.match(/session_id=([^&]+)/);
      const sessionId = m ? decodeURIComponent(m[1])
                          : new URLSearchParams(window.location.search).get("session_id");
      if (!sessionId) { setError("Missing session"); return; }
      try {
        const r = await api.post("/auth/google", { session_id: sessionId });
        localStorage.setItem(TOKEN_KEY, r.data.token);
        await refresh();
        toast.success(`Welcome ${r.data.user.name || ""}!`);
        nav(r.data.needs_onboarding ? "/onboarding/parent" : "/home");
      } catch (e) {
        setError(e?.response?.data?.detail || "Sign-in failed");
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        {!error ? (
          <>
            <Loader2 className="w-8 h-8 mx-auto animate-spin text-[hsl(var(--neu-orange))]" />
            <p className="mt-4 text-muted-foreground">Signing you in…</p>
          </>
        ) : (
          <>
            <p className="text-destructive font-medium">{error}</p>
            <button onClick={() => nav("/login")} className="btn-ghost mt-4" data-testid="callback-retry-btn">
              Back to login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
